<template>
  <svg
    id="Arrow-Left--Streamline-Solar-Ar"
    viewBox="-0.5 -0.5 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    height="16"
    width="16"
  >
    <desc>Arrow Left Streamline Icon: https://streamlinehq.com</desc>
    <path
      d="M14.219999999999999 7.5H0.78M0.78 7.5L5.819999999999999 2.46M0.78 7.5L5.819999999999999 12.54"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    ></path>
  </svg>
</template>
